(function(){
  'use strict';

  // Custom cursor — only on hover-capable (desktop) devices
  if(window.matchMedia('(hover:hover)').matches){
    var cur=document.getElementById('cur'),ring=document.getElementById('cur-ring');
    if(cur&&ring){
      document.addEventListener('mousemove',function(e){
        cur.style.left=e.clientX+'px';
        cur.style.top=e.clientY+'px';
        ring.style.left=e.clientX+'px';
        ring.style.top=e.clientY+'px';
      },false);
      document.querySelectorAll('a,button').forEach(function(el){
        el.addEventListener('mouseenter',function(){cur.style.width='20px';cur.style.height='20px';ring.style.width='52px';ring.style.height='52px';});
        el.addEventListener('mouseleave',function(){cur.style.width='12px';cur.style.height='12px';ring.style.width='36px';ring.style.height='36px';});
      });
    }
  }

  // Hamburger menu
  var ham=document.getElementById('nav-ham'),mob=document.getElementById('nav-mobile');
  if(ham&&mob){
    ham.addEventListener('click',function(){
      ham.classList.toggle('open');mob.classList.toggle('open');
      document.body.style.overflow=mob.classList.contains('open')?'hidden':'';
    });
    mob.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click',function(){ham.classList.remove('open');mob.classList.remove('open');document.body.style.overflow='';});
    });
  }

  // Scroll reveal — IntersectionObserver
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});},{threshold:0.1,rootMargin:'0px 0px -50px 0px'});
    document.querySelectorAll('.reveal').forEach(function(r){obs.observe(r);});
  }else{
    document.querySelectorAll('.reveal').forEach(function(r){r.classList.add('vis');});
  }

  // Product filter
  window.filterProd=function(cat,btn){
    document.querySelectorAll('.f-btn').forEach(function(b){b.classList.remove('active');});
    btn.classList.add('active');
    document.querySelectorAll('.prod-card').forEach(function(c){c.style.display=(cat==='all'||c.dataset.cat===cat)?'block':'none';});
  };

  // Service tabs
  window.showSvc=function(id){
    document.querySelectorAll('.svc-detail').forEach(function(d){d.classList.remove('on');});
    document.querySelectorAll('.svc-cat-lbl').forEach(function(l){l.classList.remove('on');});
    var sd=document.getElementById('sd-'+id),sl=document.getElementById('sl-'+id);
    if(sd)sd.classList.add('on');
    if(sl)sl.classList.add('on');
  };
})();
